import {
  AutoRefreshTokenService,
  createInterceptorCondition,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  IncludeBearerTokenCondition,
  provideKeycloak,
  UserActivityService,
  withAutoRefreshToken
} from 'keycloak-angular'
import {KeycloakConfig} from 'keycloak-js'

const regex = /^(https?:\/\/[^/]+)?api(?:\/.*)?$/i

const condition = createInterceptorCondition<IncludeBearerTokenCondition>({
  // urlPattern:  /^(https?:\/\/[^\/]+)?\/api.*$/,
  // urlPattern:  /^.*$/,
  // urlPattern:  /^(https?:\/\/[^\/]+)?\/api\/.*$/,
  urlPattern: regex,
  bearerPrefix: 'Bearer'
})

export const provideKeycloakAngular = (config: KeycloakConfig) => {
  return provideKeycloak({
    config,
    initOptions: {
      onLoad: 'check-sso',
      silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html'
    },
    features: [
      withAutoRefreshToken({
        onInactivityTimeout: 'none'
      })
    ],
    providers: [
      AutoRefreshTokenService,
      UserActivityService,
      {
        provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
        useValue: [condition]
      }
    ]
  })
}
